import { render, staticRenderFns } from "./YunkeList.vue?vue&type=template&id=294537e8&scoped=true"
import script from "./YunkeList.vue?vue&type=script&lang=js"
export * from "./YunkeList.vue?vue&type=script&lang=js"
import style0 from "./YunkeList.vue?vue&type=style&index=0&id=294537e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294537e8",
  null
  
)

export default component.exports